package io.horion.cv.pages.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.browser.uri.encodeURIComponent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.api.utils.Constants.AUTH_FRONTEND_URL
import io.horion.cv.components.ActionButtons
import io.horion.cv.components.Branding
import io.horion.cv.components.MobileSidebar
import io.horion.cv.components.NavLink
import io.horion.cv.components.NavLinkSidebar
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.pages.navigation.dashboardLinks
import io.horion.cv.pages.navigation.links
import io.horion.cv.styles.ActionButtonsRowStyle
import io.horion.cv.styles.CreateButtonStyle
import io.horion.cv.styles.CreateCvButtonStyle
import io.horion.cv.styles.CreateCvButtonTextStyle
import io.horion.cv.styles.DesktopNavContainerStyle
import io.horion.cv.styles.LoginButtonStyle
import io.horion.cv.styles.LoginButtonTextStyle
import io.horion.cv.styles.MobileMenuBurgerStyle
import io.horion.cv.styles.ThemeIconStyle
import io.horion.cv.styles.TopbarStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.window
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Text
import kotlin.collections.component1
import kotlin.collections.component2


@Composable
fun TopbarDashboard() {

    var showMenu by remember { mutableStateOf(false) }
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val topbarBg = if (isDark) Colors.DarkBG else Colors.White
    val borderColor = if (isDark) Colors.holder else Colors.LightGray

    Row(
        modifier = TopbarStyle.toModifier()
            .fillMaxWidth()
            .backgroundColor(topbarBg)
//            .height(if (breakpoint <= Breakpoint.MD) 58.px else 68.px)
//            .padding(leftRight =  if (breakpoint <= Breakpoint.MD) 20.px else 90.px)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = borderColor
            )
            .boxShadow(
                offsetX = 0.px,
                offsetY = 1.px,
                blurRadius = 6.px,
                spreadRadius = 1.px,
                color = rgba(0, 0, 0, 0.1)
            )
            .styleModifier {
                property("transition", "background-color 300ms ease")
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Branding(isDark = isDark)

        Spacer()

//        Row(
//            modifier = DesktopNavContainerStyle.toModifier(),
//            verticalAlignment = Alignment.CenterVertically
//        ) {
//            links.forEach { (title, path) ->
//                NavLink(title, path)
//            }
//        }

        Spacer()

        FaBarsButtons() {
            showMenu = true
        }
    }

    if (showMenu) {
        SideBarDashboard {
            showMenu = false
        }
    }
}


@Composable
fun FaBarsButtons(
    onMenuClick: () -> Unit
) {
    val ctx = rememberPageContext()
    var colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    var isAuthenticated by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
//        isAuthenticated = runCatching { TokenRepository.checkAuthentication() }.getOrDefault(false)
    }

    Row(
        modifier = ActionButtonsRowStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (isDark) {
            FaSun(
                modifier = ThemeIconStyle.toModifier()
                    .color(Colors.yellow)
                    .onClick { colorMode = colorMode.opposite }
            )
        } else {
            FaMoon(
                modifier = ThemeIconStyle.toModifier()
                    .color(Colors.Primary)
                    .onClick { colorMode = colorMode.opposite }
            )
        }

        Box(
            modifier = MobileMenuBurgerStyle.toModifier()
        ) {
            FaBars(
                modifier = Modifier
                    .color(if (isDark) Colors.White else Colors.Black)
                    .onClick { onMenuClick() }
            )
        }

    }
}
@Composable
fun SideBarDashboard(onClose: () -> Unit) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val sidebarBg = if (isDark) Colors.DarkBG else Colors.White

    Overlay(
        modifier = Modifier
            .backgroundColor(Colors.Black.copy(alpha = 128))
            .zIndex(1000)
            .onClick { onClose() }
    ) {
        Box(
            modifier = Modifier
                .fillMaxHeight()
                .width(280.px)
                .backgroundColor(sidebarBg)
                .align(Alignment.TopEnd)
                .padding(all = 20.px)
                .onClick { it.stopPropagation() }
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 1.px,
                    blurRadius = 6.px,
                    spreadRadius = 1.px,
                    color = rgba(0, 0, 0, 0.1)
                )
        ) {
            Column {
                Row(
                    modifier = Modifier
                        .fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Spacer()

                    FaXmark(
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() }
                            .fontSize(24.px)
                            .color(if (isDark) Colors.White else Colors.Black)
                    )
                }
                Column(
                    modifier = Modifier
                        .margin(top = 40.px)
                        .gap(25.px)
                ) {
                    dashboardLinks.forEach { (title, path) ->
                        NavLinkSidebar(title, path, onClose)
                    }
                }
            }
        }
    }
}
